import _ from "lodash-es";

export default function computeDefaultTableSize(data, columnName) {
  // const colData = _.flatten(_.map(data, item => _.map(data, columnName)));

  const colData = _.map(data, columnName);

  const uniqData = _.uniq(colData);
  return uniqData.length > 0 ? uniqData.length : 5;
}
